import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import DropDown from 'src/components/design-system/DropDown';
import { InvoiceLineItem } from 'src/services/useInvoiceLineItemsApi';
import { getBgColor } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const GLCodeDropDownCell: FC<GridCellProps> = (props) => {
  const { dataItem, onChange, dataIndex } = props;
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const formattedGlCodeOptions = useContextSelector(
    InvoiceContext,
    (value) => value.formattedGlCodeOptions
  );
  const lineItem: InvoiceLineItem = dataItem;

  const handleChange = useCallback(
    (e: DropDownListChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem: lineItem,
        field: 'glCd',
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    },
    [dataIndex, lineItem, onChange]
  );

  const error = useMemo(() => dataItem?.errors?.glCd, [dataItem?.errors?.glCd]);
  const warning = useMemo(() => dataItem?.warnings?.glCd, [dataItem?.warnings?.glCd]);
  const info = useMemo(() => dataItem?.informations?.glCd, [dataItem?.informations?.glCd]);

  let value = formattedGlCodeOptions.find((glCodeData) => glCodeData?.value === lineItem.glCd);

  return (
    <GridCellBase {...props} title={value?.label} className={getBgColor(error, warning, info)}>
      {isInvoiceEditDisabled ? (
        value?.label
      ) : (
        <DropDown
          onChange={handleChange}
          value={lineItem.glCd}
          options={formattedGlCodeOptions}
          valid={!error?.length}
        />
      )}
    </GridCellBase>
  );
};

export default GLCodeDropDownCell;
